import script from "./ProcurementSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcurementSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ProcurementSidebar.vue?vue&type=style&index=0&id=9aaddd16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aaddd16"]])

export default __exports__